import React, { memo, useCallback } from 'react';
import { HStack, Text, Box } from 'native-base';
import { Iconography, Typography, logUserEvent } from 'fmc-digital-common';
import { UploadBoxConstants } from '../../../constants';
export default /*#__PURE__*/memo(({
  fileName,
  errorType = 'NoFile',
  fileSize
}) => {
  const {
    NOT_VALID_FILE,
    NOT_VALID_FILE_SIZE,
    NO_FILE_PRESENT,
    ATMOST_10_FILES
  } = UploadBoxConstants;
  const ErrorMessage = useCallback(() => {
    switch (errorType) {
      case 'FileFormat':
        logUserEvent({
          action: 'InvalidfileformatErrorDisplayed',
          type: 'LIPDocUploadPopUp',
          description: `Task Section Doc Upload Task ${fileName}`
        });
        return NOT_VALID_FILE;
      case 'FileSize':
        logUserEvent({
          action: 'ExceedsizelimitErrorDisplayed',
          type: 'LIPDocUploadPopUp',
          description: `Task Section Doc Upload Task ${fileName}`
        });
        return ` is ${fileSize} ${NOT_VALID_FILE_SIZE}`;
      case 'NoFile':
        logUserEvent({
          action: 'SelectfiletoclickuploadErrorDisplayed',
          type: 'LIPDocUploadPopUp',
          description: 'Task Section Doc Upload Task - no file selected to upload'
        });
        return NO_FILE_PRESENT;
      case 'FilesLimit':
        logUserEvent({
          action: 'Morethan10filesErrorDisplayed',
          type: 'LIPDocUploadPopUp',
          description: `Task Section Doc Upload Task - more than 10 files are not allowed to upload`
        });
        return ATMOST_10_FILES;
      default:
        return 'No valid file';
    }
  }, [ATMOST_10_FILES, NOT_VALID_FILE, NOT_VALID_FILE_SIZE, NO_FILE_PRESENT, errorType, fileSize, fileName]);
  return /*#__PURE__*/React.createElement(Box, {
    py: "2",
    px: "4",
    minH: "12",
    borderRadius: 4,
    backgroundColor: 'error.100',
    alignItems: 'flex-start',
    marginTop: 2
  }, /*#__PURE__*/React.createElement(HStack, {
    flex: 1,
    space: 3,
    flexDirection: errorType === 'NoFile' ? 'row' : 'row-reverse',
    w: "100%",
    alignItems: 'center'
  }, /*#__PURE__*/React.createElement(Iconography, {
    name: 'error',
    color: 'error.300',
    size: 20
  }), /*#__PURE__*/React.createElement(HStack, {
    flex: 2,
    space: 2,
    alignItems: "center",
    marginRight: 8
  }, errorType !== 'NoFile' ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Iconography, {
    name: 'file-present',
    size: 24,
    color: "error.300"
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "regular",
    color: 'error.800',
    numberOfLines: 5
  }, /*#__PURE__*/React.createElement(Text, {
    fontWeight: '700'
  }, fileName), /*#__PURE__*/React.createElement(Text, {
    fontWeight: 'normal'
  }, ErrorMessage()))) : /*#__PURE__*/React.createElement(Typography, {
    variant: "regular",
    numberOfLines: 5,
    color: 'error.800'
  }, ErrorMessage()))));
});
//# sourceMappingURL=DocUploadSnackbar.js.map